(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 3236:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(1047);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var src_hooks_useSessionData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6831);
/* harmony import */ var src_layouts_Page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3842);





var Login = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var sessionData = (0,src_hooks_useSessionData__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
    var sessionUserType = (0,src_hooks_useSessionData__WEBPACK_IMPORTED_MODULE_3__/* .useSessionUserType */ .j4)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (sessionUserType !== src_hooks_useSessionData__WEBPACK_IMPORTED_MODULE_3__/* .ESessionUserType.Unknown */ .Ev.Unknown && sessionData && sessionData.data) {
            var ref;
            if (!((ref = sessionData.data.attributes) === null || ref === void 0 ? void 0 : ref.onboarding_completed_at)) {
                router.replace("/".concat(sessionUserType, "/on-boarding/welcome"));
            } else {
                router.replace("/".concat(sessionUserType, "/homepage"));
            }
        }
    }, [
        sessionUserType,
        router,
        sessionData
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_layouts_Page__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
            className: "my-auto px-7 text-center font-myriad text-h1 font-bold text-secondary-dark-grey",
            children: "You are not logged in, please visit your unique link to gain access"
        })
    });
};
Login.displayName = "Login";
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Login);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(3236); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);